import React from 'react';
import {
  Box,
  Container,
  Header,
  Link,
  SpaceBetween,
} from '@cloudscape-design/components';
import { CheckRow, checkName, checksNotSavedText } from './checkDisplay';
import { categoryTabId } from './CategoryTab';

/**
 * ISFR's Flags to Keep in Mind tab: every triggered flag in full, in one place,
 * each with the category it relates to. A flag did not change the agent's
 * decision, so it is not a blocker, but it is worth the reviewer's attention
 * and can change the reviewer's own call. Each category tab also lists its
 * flags, so a flag reads both where it belongs and here with the rest.
 */

export const FLAGS_TAB_ID = 'isfr-flags';

export const FlagsTab = ({ view, onOpenTab }) => {
  const { flags, checks } = view;
  const nameOf = (id) => (checks.byId.has(id) ? checkName(checks.byId.get(id)) : 'A check not shown on this record');
  let body;
  if (checks.status !== 'ok') {
    body = (
      <Box color="text-body-secondary">
        {`${checksNotSavedText(checks.status)} The executive summary on the Approval Summary tab lists any flags that fired.`}
      </Box>
    );
  } else if (flags.length === 0) {
    body = <Box>No flags triggered.</Box>;
  } else {
    body = (
      <SpaceBetween size="l">
        {flags.map((flag) => (
          <div key={flag.id} data-testid="isfr-flag">
            <CheckRow
              check={flag}
              nameOf={nameOf}
              context={(
                <Box variant="small" color="text-body-secondary">
                  {'Relates to '}
                  {onOpenTab
                    ? <Link fontSize="body-s" onFollow={() => onOpenTab(categoryTabId(flag.categoryKey))}>{flag.categoryLabel}</Link>
                    : flag.categoryLabel}
                </Box>
              )}
            />
          </div>
        ))}
      </SpaceBetween>
    );
  }
  return (
    <Container
      header={(
        <Header
          variant="h2"
          description="These are not hard blockers. They did not change the agent's decision, but each is worth your attention and could change yours."
        >
          Flags to Keep in Mind
        </Header>
      )}
    >
      <div data-testid="isfr-flags-body">{body}</div>
    </Container>
  );
};

/** The flags tab's label: marked when any flag fired. */
export const flagsTabLabel = (view) => (
  view.checks.status === 'ok' && view.flags.length > 0 ? '⚠️ Flags to Keep in Mind' : 'Flags to Keep in Mind'
);
